import { createIcons, icons } from "lucide";

const initializeLucideIcons = (): void => {
  createIcons({
    icons, // Import all icons for simplicity
    attrs: {
      // Default attributes from your original lucide.ts
      "stroke-width": "1.5",
      stroke: "#333",
    },
  });
};

export { initializeLucideIcons };
